import standardAPI from '@/api/standard_items';

const responseUrl = '/world-tours/languages';

const state = {
  languages: [],
  languages_MetaData: {},
  languages_status: '',
  languages_page: 1,
  languages_perPage: 10,
};

const getters = {
  get_languages: (state) => {
    return state.languages;
  },
  get_languages_status: (state) => {
    return state.languages_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_languages ({ commit }, getOptions) {
    commit('DATA_LANGUAGES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_LANGUAGES_UPDATE_SUCCESS', response);
            commit('DATA_LANGUAGES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_LANGUAGES_READY');
            reject(response);
          } else {
            commit('DATA_LANGUAGES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_languages_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  change_request_status ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/' + itemData.id + '/change-status',
      method: 'put',
    };
    return new Promise((resolve, reject) => {
      standardAPI.universal_response(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.languages_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.languages_perPage = max;
  },
  DATA_LANGUAGES_READY: (state) => {
    state.languages_status = 'ready';
  },
  DATA_LANGUAGES_REQUEST: (state) => {
    state.languages_status = 'loading';
  },
  DATA_LANGUAGES_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.languages_MetaData.meta = response.meta;
      state.languages_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.languages = response.data || [];
    }
    state.languages_status = 'success';
  },
  DATA_LANGUAGES_ERROR: (state) => {
    state.languages_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
